// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1UnJH","title":"BackImages_title__1hXdI","images":"BackImages_images__2GyFg"};